/** MIME-тип для dataTransfer при D&D проекта в чат (Ctrl+drag) */
export const PROJECT_DRAG_TYPE = 'application/project-attach';

/** MIME-тип для dataTransfer при D&D сессии в чат (Ctrl+drag) */
export const SESSION_CHAT_ATTACH_TYPE = 'application/session-attach';
